import { render, staticRenderFns } from "./course-map.vue?vue&type=template&id=a2cc64f0"
import script from "./course-map.vue?vue&type=script&lang=ts"
export * from "./course-map.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports